import { useCallback } from "react";
import { useAppDispatch } from "../../../app/hooks";
import { ProductImageInterface } from "../../interfaces/apiV2/shared/ProductImageInterface";
import {
    setActive,
    setLightboxSlices,
} from "../../../modals/productGalleryModal/productGalleryModalSlice";

export const useProductDetailGallery = (): ((
    images: ProductImageInterface[],
) => void) => {
    const dispatch = useAppDispatch();

    return useCallback(
        (images: ProductImageInterface[]) => {
            dispatch(setLightboxSlices(images));
            dispatch(setActive(true));
        },
        [dispatch],
    );
};
